module.exports = __webpack_public_path__ + "static/Noobs-53350430969b575102a2a32a57af2d75.gif";